module.exports = __webpack_public_path__ + "img/thumbnail_DromedaryCamel_j_erythristic.704c863e.png";